"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupRequestsContextProvider = exports.GroupRequestsContext = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var getContextFromProps_1 = require("../getContextFromProps");
var defaultUserContext = {
    groupRequestsActions: undefined,
    groupRequestsResponse: undefined,
    groupRequestsStatus: undefined,
};
exports.GroupRequestsContext = react_1.default.createContext(defaultUserContext);
var GroupRequestsContextProvider = function (_a) {
    var children = _a.children, value = _a.value;
    var _value = getContextFromProps_1.getContextFromProps(value, defaultUserContext);
    return (react_1.default.createElement(exports.GroupRequestsContext.Provider, { value: _value }, children));
};
exports.GroupRequestsContextProvider = GroupRequestsContextProvider;
exports.GroupRequestsContextProvider.displayName = 'GroupRequestsContextProvider';
//# sourceMappingURL=GroupRequestsContext.js.map